import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { ProgressiveImage } from "@/react/components/shared/ProgressiveImage";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";
import emptyRecommendation1x from "./images/emptyRecommendation.png";
import emptyRecommendation2x from "./images/emptyRecommendation@2x.png";
import emptyRecommendation3x from "./images/emptyRecommendation@3x.png";

const emptyRecommendationImageVariants = {
  thumbnail: emptyRecommendation1x,
  small: emptyRecommendation1x,
  medium: emptyRecommendation2x,
  large: emptyRecommendation3x,
};

const i18nBase = "members_directory.recommendations";

export const EmptyRecommendations = () => {
  const history = useHistory();
  return (
    <div className="flex flex-col items-center justify-center gap-y-14">
      <div className="mt-14 flex flex-1 items-center justify-center">
        <ProgressiveImage
          src={emptyRecommendationImageVariants.large}
          srcVariants={emptyRecommendationImageVariants}
          alt={t(`${i18nBase}.empty_list.title`)}
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-y-8">
        <div className="flex flex-col justify-center gap-y-2 text-center">
          <Typography.TitleLg weight="bold" color="text-primary">
            {t(`${i18nBase}.empty_list.title`)}
          </Typography.TitleLg>
          <Typography.BodySm>
            {t(`${i18nBase}.empty_list.description`)}
          </Typography.BodySm>
        </div>
        <Button
          onClick={() => {
            history.push("/members");
          }}
          variant="secondary"
          className="w-fit"
        >
          {t(`${i18nBase}.empty_list.button`)}
          <Icon type="16-arrow-right" size={16} className="ml-2" />
        </Button>
      </div>
    </div>
  );
};
